function getNumProds(jaja, xd){
    var i = 0
    var nums = 0
    for(; i < JSON.parse(localStorage.getItem("carrito")).length;){
        nums = nums + JSON.parse(localStorage.getItem("carrito"))[i].cant
        i++;
    }
    jaja(xd('totalProds', nums))
}

export {getNumProds};